var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.237,
    height: 85.41,
    viewBox: "0 0 77.237 85.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-3{fill:#f8c201;fill-rule:evenodd}.cls-4{fill:#f5f5f5}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "price-tag",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, -37.1, -26.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3029",
    fill: "#faa515",
    d: "M89.44 104.5l-11.981 5.836a5.186 5.186 0 0 0-2.418 2.544l-14.947 37.47a6.929 6.929 0 0 0 3.52 9.136l14.867 6.588h11.041z",
    transform: "translate(0 -87.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3030",
    fill: "#fad207",
    d: "M215.951 151.341v7.218a7.458 7.458 0 0 1-7.382 7.382h-30.35a7.317 7.317 0 0 1-7.219-7.382v-42.49a5.309 5.309 0 0 1 1.166-3.447l9.125-11.056a5.408 5.408 0 0 1 4.145-2.066h15.914a5.409 5.409 0 0 1 4.145 2.066l9.125 11.056a5.47 5.47 0 0 1 1.33 3.447v35.272z",
    transform: "translate(-93.207 -83.178)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1740",
    transform: "translate(88.168 42.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    d: "M243.792 265.789l-.042-.042-.068-.068-1.7-1.7-.241.48a5.308 5.308 0 0 0-1.8-.312h-.164a5.329 5.329 0 0 0-5.039 7.071l-.5.256 1.762 1.761.022.022.024.024a5.313 5.313 0 0 0 3.733 1.53h.164a5.328 5.328 0 0 0 3.844-9.021zm-3.844 6.56h-.164a2.871 2.871 0 0 1 0-5.742h.164a2.871 2.871 0 1 1 0 5.742z",
    className: "cls-3",
    transform: "translate(-234.247 -263.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    d: "M262.076 259.838l-1.641-1.641-22.735 22.739 1.641 1.641a1.231 1.231 0 0 0 1.74 0l21-21a1.231 1.231 0 0 0-.005-1.739z",
    className: "cls-3",
    transform: "translate(-237.13 -258.197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3033",
    d: "M341.7 344.944l-1.357-1.376.088.558a5.3 5.3 0 0 0-2.222-.487h-.164a5.329 5.329 0 0 0-4.883 7.469l-.6-.088 1.633 1.63q.087.092.179.179l.037.037a5.312 5.312 0 0 0 3.636 1.437h.164a5.328 5.328 0 0 0 3.49-9.358zm-3.49 6.9h-.164a2.871 2.871 0 0 1 0-5.742h.164a2.871 2.871 0 1 1 0 5.742z",
    className: "cls-3",
    transform: "translate(-316.433 -329.562)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1741",
    transform: "translate(86.733 41.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3034",
    d: "M236.73 279.46a1.23 1.23 0 0 1-.87-2.1l21-21a1.23 1.23 0 0 1 1.74 1.74l-21 21a1.226 1.226 0 0 1-.87.36z",
    className: "cls-4",
    transform: "translate(-233.859 -255.836)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3035",
    d: "M231 265.663h-.164a5.332 5.332 0 1 1 0-10.663H231a5.332 5.332 0 1 1 0 10.663zm-.164-8.2a2.871 2.871 0 0 0 0 5.742H231a2.871 2.871 0 0 0 0-5.742z",
    className: "cls-4",
    transform: "translate(-225.5 -255)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3036",
    d: "M329 344.663h-.164a5.332 5.332 0 0 1 0-10.663H329a5.332 5.332 0 1 1 0 10.663zm-.164-8.2a2.871 2.871 0 0 0 0 5.742H329a2.871 2.871 0 1 0 0-5.742z",
    className: "cls-4",
    transform: "translate(-307.423 -321.04)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3037",
    fill: "#e0a446",
    d: "M317.532 26.329a1.231 1.231 0 0 1-.341-2.413c.14-.04.28-.085.418-.132a9.269 9.269 0 0 0 6.273-8.774V1.229a1.23 1.23 0 1 1 2.461 0V15.01a11.729 11.729 0 0 1-7.939 11.1c-.174.059-.352.115-.529.167a1.226 1.226 0 0 1-.343.052z",
    transform: "translate(-214.672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3038",
    d: "M288.355 139.711a3.855 3.855 0 1 1 3.855-3.855 3.86 3.86 0 0 1-3.855 3.855z",
    className: "cls-4",
    transform: "translate(-188.087 -110.346)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTag);
export default __webpack_public_path__ + "static/media/price-tag.4364f8eeb5139c6b217fb5db05feea21.svg";
export { ForwardRef as ReactComponent };